import React, {
  useEffect,
  useState
} from 'react';

import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Typography
} from '@mui/material';

import {
  Link
} from 'react-router-dom';

import {
  useTranslation
} from 'react-i18next';

import {
  MOODLE_URL
} from '../config';

import apiClient from
  '../services/apiClient';

import {
  useLanguage
} from '../contexts/LanguageContext';

import {
  localized
} from '../utils/localizedContent';

const FALLBACK_CARDS = [
  'individualConsulting',
  'organizationConsulting',
  'factoryConsulting'
];

export default function Home() {
  const {
    t
  } = useTranslation();

  const {
    language
  } = useLanguage();

  const [
    homeContent,
    setHomeContent
  ] = useState(null);

  useEffect(() => {
    let active = true;

    apiClient
      .get(
        '/admin/content-settings/public'
      )
      .then(response => {
        if (!active) {
          return;
        }

        setHomeContent(
          response?.data?.data?.homePage
          || null
        );
      })
      .catch(() => {
        if (active) {
          setHomeContent(null);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  const heroTitle =
    localized(
      homeContent?.heroTitle,
      language
    )
    || t('heroTitle');

  const heroSubtitle =
    localized(
      homeContent?.heroSubtitle,
      language
    )
    || t('heroSubtitle');

  const configuredFeatures =
    Array.isArray(
      homeContent?.features
    )
      ? homeContent.features
          .filter(feature =>
            feature
            && (
              localized(
                feature.title,
                language
              )
              || localized(
                feature.description,
                language
              )
            )
          )
      : [];

  return (
    <>
      <Box
        sx={{
          py: 10,
          bgcolor: '#e8f5e9'
        }}
      >
        <Container>
          <Typography
            variant="h2"
            fontWeight="bold"
          >
            {heroTitle}
          </Typography>

          <Typography
            variant="h5"
            sx={{
              my: 3,
              maxWidth: 850
            }}
          >
            {heroSubtitle}
          </Typography>

          <Button
            variant="contained"
            size="large"
            component={Link}
            to="/request-consultation"
          >
            {t('requestConsultation')}
          </Button>

          {' '}

          <Button
            size="large"
            component={Link}
            to="/services"
          >
            {t('browseServices')}
          </Button>
        </Container>
      </Box>

      <Container sx={{ py: 7 }}>
        <Grid
          container
          spacing={3}
        >
          {configuredFeatures.length > 0
            ? configuredFeatures.map(
                (
                  feature,
                  index
                ) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    key={
                      feature._id
                      || feature.id
                      || index
                    }
                  >
                    <Paper
                      sx={{
                        p: 4,
                        height: '100%'
                      }}
                    >
                      <Typography
                        variant="h5"
                      >
                        {
                          localized(
                            feature.title,
                            language
                          )
                        }
                      </Typography>

                      <Typography
                        sx={{ mt: 2 }}
                      >
                        {
                          localized(
                            feature.description,
                            language
                          )
                        }
                      </Typography>
                    </Paper>
                  </Grid>
                )
              )
            : FALLBACK_CARDS.map(
                key => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    key={key}
                  >
                    <Paper
                      sx={{
                        p: 4,
                        height: '100%'
                      }}
                    >
                      <Typography
                        variant="h5"
                      >
                        {t(key)}
                      </Typography>

                      <Typography
                        sx={{ mt: 2 }}
                      >
                        {
                          t(
                            'serviceCardDescription'
                          )
                        }
                      </Typography>
                    </Paper>
                  </Grid>
                )
              )}
        </Grid>

        <Paper
          sx={{
            p: 4,
            mt: 6,
            bgcolor: '#f5f5f5'
          }}
        >
          <Typography variant="h4">
            {t('educationTraining')}
          </Typography>

          <Typography sx={{ my: 2 }}>
            {t('moodleDescription')}
          </Typography>

          <Button
            variant="outlined"
            href={MOODLE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('goToLearning')}
          </Button>
        </Paper>
      </Container>
    </>
  );
}
